import "../../styles/all.css"
import "./brand.css"
import Google from "../../img/Google.png"
import  amazong from "../../img/Amazon.png"
import nike from "../../img/Nike.png"
function Barnd(){
    return(
        <>
        <div className="image">
            <img src={Google} alt="" />
            <img src={amazong} alt="" />
            <img src={nike} alt="" />

        </div>
        </>
    )
}
export default Barnd